import { Box, Chip, Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material'
import { titleFromSlug } from '@/hooks/titleFromSlug'

const scopeLabel = (scope) => String(scope).replace(/^https?:\/\//, '').replace(/[./:_-]+/g, ' ')

export default function IntegrationAccessPermissionDialog({ open, onClose, groups }) {
  const hasOperationSpecificPermissions = groups.some((group) => (group.preview?.tools ?? []).length > 0)
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{hasOperationSpecificPermissions ? 'Permissions needed' : 'Connection needed'}</DialogTitle>
      <DialogContent>
        <Typography sx={{ color: 'text.secondary', fontSize: 13, mb: 2 }}>
          {hasOperationSpecificPermissions
            ? 'These are provider descriptions of the capabilities requested for this task.'
            : 'This request only establishes the provider connection. No operation-specific permissions have been selected yet.'}
        </Typography>
        <Stack sx={{ gap: 2 }}>
          {groups.map((group) => (
            <Box key={group.id ?? group.toolkit_slug}>
              <Typography sx={{ fontWeight: 650 }}>{titleFromSlug(group.toolkit_slug)}</Typography>
              {group.rationale ? <Typography sx={{ color: 'text.secondary', fontSize: 13, mt: 0.25 }}>Why the agent asked: {group.rationale}</Typography> : null}
              {(group.preview?.tools ?? []).map((tool) => (
                <Box key={tool.slug} sx={{ mt: 1 }}>
                  <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{tool.name ?? tool.slug}</Typography>
                  <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>{tool.description || 'Provider capability requested for this task.'}</Typography>
                </Box>
              ))}
              {(group.preview?.tools ?? []).length === 0 ? (
                <Typography sx={{ fontSize: 13, color: 'text.secondary', mt: 1 }}>
                  Provider default connection profile
                </Typography>
              ) : null}
              <Stack direction="row" sx={{ gap: 0.5, flexWrap: 'wrap', mt: 1 }}>
                {(group.preview?.scopes_required ?? []).map((scope) => <Chip key={scope} label={scopeLabel(scope)} size="small" />)}
              </Stack>
            </Box>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
